import { gsap } from 'gsap';

export default class ProcessAnimationSubrosa {
	constructor(elm) {
		this.elm = elm;

		this.dot1 = this.elm.querySelector('[data-process-animation-subrosa-dot1]');
		this.dot2 = this.elm.querySelector('[data-process-animation-subrosa-dot2]');

		this.tl = gsap.timeline({
			repeat: -1,
			repeatDelay: 0,
		});

		gsap.set(this.dot1, {
			xPercent: -60,
			'--dot-blur': '25px',
		});

		gsap.set(this.dot2, {
			xPercent: 60,
			'--dot-blur': '25px',
		});

		this.tl.to(
			this.dot1,
			{
				duration: 6,
				xPercent: 40,
				'--dot-blur': '3px',
				'--dot-saturation': 0.5,
				ease: 'power2.inOut',
			},
			0
		);

		this.tl.to(
			this.dot2,
			{
				duration: 6,
				xPercent: -40,
				'--dot-blur': '3px',
				'--dot-saturation': 0.5,
				ease: 'power2.inOut',
			},
			0
		);

		this.tl.to(
			this.dot1,
			{
				duration: 6,
				xPercent: -60,
				'--dot-blur': '25px',
				'--dot-saturation': 0,
				ease: 'power2.inOut',
			},
			6
		);

		this.tl.to(
			this.dot2,
			{
				duration: 6,
				xPercent: 60,
				'--dot-blur': '25px',
				'--dot-saturation': 0,
				ease: 'power2.inOut',
			},
			6
		);
	}
}
